export enum AdUnitMarketClassification {
  OwnedAndOperatedCore = 'OwnedAndOperatedCore',
  OwnedAndOperated = 'OwnedAndOperated',
  Syndicated = 'Syndicated',
  SelectTier = 'SelectTier',
  Sponsored = 'Sponsored',
  SponsoredEnhanced = 'SponsoredEnhanced',
}
